import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import templateService from 'src/services/apiServices/document-management/template-service';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';
import { DashboardConstants } from 'src/redux/actions/constant';
const {
    GET_MY_DASHBOARD_DOCUMENT_REQUEST,
    GET_MY_DASHBOARD_DOCUMENT_SUCCESS,
    GET_MY_DASHBOARD_DOCUMENT_FAILURE,
    GET_MY_DASHBOARD_DOCUMENT_LOADER,
    GET_MY_DASHBOARD_DOCUMENT_RESET,
} = DashboardConstants;

function* getAllMySubmittedDocumentOfDashboard(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_MY_DASHBOARD_DOCUMENT_LOADER });
    const response = yield call(dashboardServices.getMyDashboardDocument, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_MY_DASHBOARD_DOCUMENT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_MY_DASHBOARD_DOCUMENT_FAILURE, payload: error });
  }
}

function* myDashboardDocumentListSaga() {
  yield takeEvery(GET_MY_DASHBOARD_DOCUMENT_REQUEST, getAllMySubmittedDocumentOfDashboard);
}

export default myDashboardDocumentListSaga;
